import AppOpenRoutes from 'resources/assets/react-app/routes/openRoutes';

import asyncComponent from 'Demora/AsyncComponent';

const packageRoutes = [
	{
		path: '/',
		component: asyncComponent(
			() =>
				import(
					/* webpackChunkName: "home" */ 'resources/assets/react-app/components/HomePage'
				)
		),
	},
	{
		path: '/password/reset',
		component: asyncComponent(
			() => import(/* webpackChunkName: "preset" */ './ForgottenPassword')
		),
	},
	{
		path: '/password/reset/:token',
		component: asyncComponent(
			() => import(/* webpackChunkName: "preset" */ './ResetPassword')
		),
	},
	{
		path: '/terms',
		component: asyncComponent(
			() =>
				import(
					/* webpackChunkName: "terms" */ 'resources/assets/react-app/components/Terms'
				)
		),
	},
	{
		path: '/privacy',
		component: asyncComponent(
			() =>
				import(
					/* webpackChunkName: "privacy" */ 'resources/assets/react-app/components/Privacy'
				)
		),
	},
	{
		path: '/upgrade/complete',
		component: asyncComponent(
			() =>
				import(
					/* webpackChunkName: "upgradecomplete" */ 'resources/assets/react-app/components/UpgradeComplete'
				)
		),
	},
	{
		path: '/login',
		component: asyncComponent(
			() => import(/* webpackChunkName: "login" */ './login/_index')
		),
	},
	{
		path: '/login/multi',
		component: asyncComponent(
			() =>
				import(
					/* webpackChunkName: "prot-auth-billing" */ './login/TeamSelector'
				)
		),
	},
	{
		path: '/logout',
		component: asyncComponent(
			() => import(/* webpackChunkName: "logout" */ './Logout')
		),
	},
	{
		path: '/maintenance',
		component: asyncComponent(
			() => import(/* webpackChunkName: "logout" */ './Maintenance')
		),
	},
	{
		path: '/signup',
		component: asyncComponent(
			() => import(/* webpackChunkName: "signup" */ './Signup')
		),
	},
	{
		path: '/contact',
		component: asyncComponent(
			() => import(/* webpackChunkName: "contact" */ './Contact')
		),
	},
	{
		path: '/setup',
		component: asyncComponent(
			() => import(/* webpackChunkName: "setup" */ './Setup')
		),
	},
	{
		path: '/setup/:id/:code',
		component: asyncComponent(
			() => import(/* webpackChunkName: "setup" */ './Setup')
		),
	},
];

/*
 * App routes are matched before the package's own, so an app can serve its
 * own '/' or '/contact' without the package's version shadowing it —
 * Router renders inside a <Switch>, where the first match wins.
 *
 * A catch-all is the one exception: it has to sit after every package
 * route or it would swallow /login, /admin and the rest.
 */
const isCatchAll = (r) => r.path === '*';

const routes = AppOpenRoutes.filter((r) => !isCatchAll(r)).concat(
	packageRoutes,
	AppOpenRoutes.filter(isCatchAll)
);

export default routes;
